/**
 * Formatear fecha
 */
export const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('es-AR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};

/**
 * Calcular edad en años y meses
 */
export const calcularEdad = (fechaNacimiento) => {
  if (!fechaNacimiento) return '-';
  const hoy = new Date();
  const nacimiento = new Date(fechaNacimiento);
  
  let años = hoy.getFullYear() - nacimiento.getFullYear();
  let meses = hoy.getMonth() - nacimiento.getMonth();
  
  if (meses < 0) {
    años--;
    meses += 12;
  }
  
  if (años === 0) {
    return `${meses} meses`;
  } else if (meses === 0) {
    return `${años} ${años === 1 ? 'año' : 'años'}`;
  } else {
    return `${años}a ${meses}m`;
  }
};

/**
 * Calcular edad en meses
 */
export const calcularEdadMeses = (fechaNacimiento) => {
  if (!fechaNacimiento) return 0;
  const hoy = new Date();
  const nacimiento = new Date(fechaNacimiento);
  
  const años = hoy.getFullYear() - nacimiento.getFullYear();
  const meses = hoy.getMonth() - nacimiento.getMonth();
  
  return años * 12 + meses;
};

/**
 * Formatear número con separador de miles
 */
export const formatNumber = (num) => {
  if (num === null || num === undefined) return '-';
  return num.toLocaleString('es-AR');
};

/**
 * Formatear porcentaje
 */
export const formatPercent = (num, decimals = 1) => {
  if (num === null || num === undefined) return '-';
  return `${num.toFixed(decimals)}%`;
};

/**
 * Obtener color por categoría
 */
export const getCategoriaColor = (categoria) => {
  const colors = {
    ternero: 'bg-pink-100 text-pink-800',
    desmamante: 'bg-purple-100 text-purple-800',
    vaquilla: 'bg-cyan-100 text-cyan-800',
    novillo: 'bg-orange-100 text-orange-800',
    vaca: 'bg-blue-100 text-blue-800',
    toro: 'bg-green-100 text-green-800',
  };
  return colors[categoria] || 'bg-gray-100 text-gray-800';
};

/**
 * Obtener color por estado
 */
export const getEstadoColor = (estado) => {
  const colors = {
    activo: 'bg-green-100 text-green-800',
    vendido: 'bg-blue-100 text-blue-800',
    muerto: 'bg-red-100 text-red-800',
    descartado: 'bg-gray-100 text-gray-800',
  };
  return colors[estado] || 'bg-gray-100 text-gray-800';
};

/**
 * Obtener badge de prioridad de alerta
 */
export const getPrioridadColor = (prioridad) => {
  const colors = {
    alta: 'bg-red-100 text-red-800',
    media: 'bg-yellow-100 text-yellow-800',
    baja: 'bg-green-100 text-green-800',
  };
  return colors[prioridad] || 'bg-gray-100 text-gray-800';
};
